import { Grid, Slide } from '@mui/material';
import { CrossIcon, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import HeaderBackground from '../../../../assets/img/upgrade-subscription-modal/header-background.png';
import { Text } from '../../../../react-components/Text';

interface AccountDeletionSlideProps {
  onClose: () => void;
  openSlide: boolean;
  titleId: string;
  subtitleId: string;
  children: React.ReactNode;
}

export const AccountDeletionSlide = ({
  openSlide,
  onClose,
  titleId,
  subtitleId,
  children,
}: AccountDeletionSlideProps) => {
  return (
    <Slide
      key="account-deletion-slide"
      in={openSlide}
      direction="up"
      mountOnEnter
      unmountOnExit
      timeout={{ enter: 400, exit: 300 }}
      style={{ top: 0, zIndex: 10010, position: `absolute` }}
    >
      <Grid
        style={{
          height: `100%`,
          width: `100%`,
          overflowY: `hidden`,
          background: RoutalPalette.white,
        }}
      >
        <Grid
          container
          style={{
            position: `relative`,
            borderBottomLeftRadius: `50px`,
            borderBottomRightRadius: `50px`,
            backgroundImage: `url(${HeaderBackground})`,
            backgroundSize: `cover`,
            backgroundPosition: `center`,
            height: `33%`,
            maxHeight: `300px`,
          }}
        >
          <CrossIcon
            style={{
              position: `absolute`,
              color: RoutalPalette.white,
              height: `32px`,
              width: `32px`,
              fontSize: `32px`,
              cursor: `pointer`,
              top: `20px`,
              left: `20px`,
            }}
            onClick={() => onClose()}
          />
        </Grid>

        <Grid
          container
          direction="column"
          style={{ padding: `20px`, height: `66%`, flexWrap: `nowrap`, justifyContent: `space-between` }}
        >
          <Grid container direction="column" gap="8px">
            <Text variant="h5" intlId={titleId} />

            <Text variant="body-large" style={{ color: RoutalPalette.secondary00 }} intlId={subtitleId} />
          </Grid>

          <VSpacer large />

          {children}
        </Grid>
      </Grid>
    </Slide>
  );
};
